import React, { useCallback, useEffect, useState } from 'react';
import axiosInstance from '../axiosApi';
import { Table, message, Pagination, Modal, Spin } from 'antd';
// import { connect } from 'react-redux';
// import { PageSelector } from '../features/ServerSidePaginator/Ssp';
import { useAppDispatch, useAppSelector } from '../redux/hooks';

import {
//    paginationPrev,
//    paginationNext,
//    paginationExact,
//    pageGoto,
    populateItems,
} from '../features/ServerSidePaginator/sspSlice';

const modalContext = React.createContext({});
/*
const modalContent = {
    title: 'Recepient phone numbers',
    content: (
        <>
            <modalContext.Consumer>{phone_list => `${phone_list}`}</modalContext.Consumer>
        </>
    ),
}
*/ 
export default function ShoutHistory(props: any) {
//    const urlPrev = useAppSelector((state) => state.ssp.urlPrev);
//    const urlNext = useAppSelector((state) => state.ssp.urlNext);
    const [loading, setLoading] = useState(true);
//    const [history, setHistory] = useState([]);
    const dispatch = useAppDispatch();
    // const [selectedPage, setSelectedPage] = useState('2');
    const [pageNumber, setPageNumber] = useState(useAppSelector((state) => state.ssp.indexCurrent || 1));
    const [, setPageSize] = useState(useAppSelector((state) => state.ssp.pageSize));
    // const [, setModalVisible] = useState(false);
    /*
    const expandable = {
        expandedRowRender: (record: any) => record.d_j.phone_list, //.forEach((i:string) => {{<p>PHONE {i}</p>}}),
        rowExpandable: (record: any) => record.d_j.phone_list instanceof Array,
        defaultExpandAllRows: false,
    };
    */

    const [, contextHolder] = Modal.useModal();

    const columns = [
        {
            title: 'Time Stamp',
            dataIndex: 'created',
            key: 'created',
        },
        {
            
            title: 'Message',
            dataIndex: 'body',
            // key: 'data.data',
            key: 'body'
        },
        {
            title: 'Sender',
            dataIndex: 'user',
            key: 'user',
        },
        {
            title: 'Branch',
            dataIndex: 'branch',
            key: 'branch',
        },
    ];

    const nestedColumns = [
        {
            title: 'Destination',
            dataIndex: 'destination',
            key: 'destination'
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status'
        },
        /*
        {list.map((item) => (
                                            <div key={`${item.source}-${item.id}`}>
                                            {`${item.status} - ${item.destination}`}
                                            </div>
                                        ))}
        */
    ]

    

    const load = useCallback((urlPath: string, queryArgs: string) => {
        try { // does NOT effect promises (.then(s))
            axiosInstance.get(urlPath + queryArgs)
                .then(res => {
                    try {
                        // There's a situation where the responses are malformed for what the table wants. They're supposed to be json objects but they're strings instead.. 

                        // proper json schema is: {"message_body": "some_text", "url": "support@rubi.works", "phone_list": ["+1234567890", "+0987654321"], "notification_sid": ["sid1"]}
                        // var results = res.data.results;
                        const newResults = res.data.results.map((item: any) => {
                            let newItem = { ...item };
                            try {
 
                                // let strCheck = JSON.parse(newItem.data);
                                newItem.data = newItem.data.replace(
                                    /'([^'\\]*(?:\\.[^'\\]*)*)'/g,
                                    (_: any, inner: any) => `"${inner.replace(/\\'/g, "'")}"`
                                )
                                .replace(/(?<!\\)\\(?![\\/"bfnrtu])/g, "\\\\");
                                // JSON.parse(newItem.data);
                                console.log(newItem);
                                /*
                                if (typeof strCheck === 'string') {
                                    throw new Error("Data is a string, not an object");
                                }
                                */
                            }
                            catch (e) {
                                newItem.data = JSON.stringify({
                                    message_body: newItem.data.message_body,
                                    phone_list: newItem.data.phone_list,
                                    url: "None",
                                    notification_sid: "Twilio returned an error for the SID."

                                });

                                newItem.queue = JSON.stringify({
                                    message_body: newItem.data.message_body,
                                    phone_list: newItem.data.phone_list,
                                    url: "None",
                                    notification_sid: "Twilio returned an error for the SID."

                                });
                            }
                            

                            // const normalized = newItem.data.replace(/'([^']*)'/g, '"$1"');

                            // Step 3: Validate final result
                            // JSON.parse(normalized);

                            // return normalized;
                            return newItem;
                        });
                        res.data.results = newResults;

                        dispatch(populateItems(res.data));
                        setLoading(false);
                    } catch (e) {
                        console.log(
                            res.statusText + "; " +
                            res.config.url + "-> " +
                            (res.data.length ? "(some data)" : "no data") + "\n" +
                            e
                        );
                        setLoading(false);
                        loadFail();
                    }
                });
        } catch (error) {
            console.log("Error Loading Histories: ", JSON.stringify(error, null, 4));
        }
    }, [dispatch]);

    useEffect(() => {
        load("shout/history/", "?page=1");
        setPageSize(50);

    }, [load]);

    const loadFail = () => {
        message.warning("Loading data failed.");
    };

    /*
    const showModal = (e: any) => {

        setModalVisible(true);
    };
    */

    /*
    const onModalOK = () => {
        setModalVisible(false);
    };
    */

    
    return (
        <modalContext.Provider value={["don't know"]}>
            <div>
                <div>
                    <Spin spinning={loading}>
                    <Table
                        // columns={columns}
                        columns={columns}
                        pagination={false}
                        rowKey={(record: any) => record?.d_j?.key || record.id}                       

                        expandable={{
                            expandedRowRender: (record: any) => {
                                const bodyArray = Array.isArray(record.queue) ? record.queue : [];
                                // const djArray = Array.isArray(record?.d_j?.message_body) ? record.d_j.message_body : [];

                                // merge and deduplicate by 'id'
                                
                                const merged = [...bodyArray, /* ...djArray */ ];
                                const seen = new Set();
                                const list = merged.filter((item) => {
                                    const key = item.id; // or `${item.id}-${item.source}` if needed
                                    if (seen.has(key)) return false;
                                    seen.add(key);
                                    return true;
                                });
                                

                                if (!list.length) return <div>No data</div>;                               

                                return (
                                    <Table
                                        columns={nestedColumns}
                                        dataSource={record.queue} // directly use nested data
                                        pagination={false}
                                        size="small"
                                        rowKey={record.queue.id}
                                    />
                                        
                                );
                            },
                            rowExpandable: (record: any) => (Array.isArray(record.queue) && record.queue.length > 0),                        
                        }}
                        dataSource={useAppSelector((state) => state.ssp.items)}
                        
                        
                    />
                    </Spin>



                    <Pagination
                        defaultCurrent={1}
                        // defaultPageSize={1}
                        current={pageNumber}
                        total={useAppSelector((state) => state.ssp.itemCount)}
                        pageSize={useAppSelector((state) => state.ssp.pageSize)}
                        onChange={(page: number, pageSize?: number | undefined) => {
                            setPageNumber(page);
                            load("shout/history/", "?page=" + page);
                        }} />

                    {contextHolder}

                </div>
            </div>
        </modalContext.Provider>

    )
}
